module.exports = __webpack_public_path__ + "img/everything_in_one_place.775cfea9.png";